import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>((theme: Theme) =>
createStyles({
  root: {
    borderTop: '5px solid #243039',
    height: '100%',
    position: 'relative',
    '& iframe': {
      border: 0,
      width: '100%',
      height: '100%',
    }
  },
}),
);
